import React from 'react';

/**
 * 28px stroke-only "+" used inside the mobile bottom nav's raised
 * "Sell" CTA. Inherits stroke color from the parent (white on the
 * marketplaceColor circle).
 */
const IconPlus = props => (
  <svg
    className={props.className}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M14 5v18M5 14h18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default IconPlus;
